var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 305.657,
    height: 79.369,
    viewBox: "0 0 305.657 79.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-243.014 -266.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M374.517,290.3h-1.655a2.355,2.355,0,0,0-2.666,2.663V308.1h6.97V292.961A2.349,2.349,0,0,0,374.517,290.3Z",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M268.253,290.3h-4.239v34.464h4.563q2.4,0,2.4-2.027V293.587C270.98,291.389,270.068,290.3,268.253,290.3Z",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M474.5,290.3h-1.655a2.356,2.356,0,0,0-2.664,2.663V308.1h6.977V292.961A2.351,2.351,0,0,0,474.5,290.3Z",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M243.014,266.211V345.58H548.671V266.211Zm34.048,57.479q0,6.586-7.29,6.6H257.931v-45.5H268.5q8.558,0,8.558,8.748Zm14.637,6.6h-6.087v-45.5H291.7Zm27.5-32.639h-6.079v-4.06c0-2.2-.875-3.288-2.6-3.288H309c-1.77,0-2.668,1.09-2.668,3.288v27.881c0,2.2.9,3.294,2.668,3.294h4.121V313.621h-3.173V308.1H319.2v22.185H307.287q-7.026,0-7.035-7.676V292.578q0-7.788,7.035-7.792h4.183q7.725,0,7.728,7.921Zm14.188,32.639h-6.077v-45.5h6.077Zm24.4-39.987h-5.831v39.988h-6.086V290.3h-5.824v-5.513h17.741Zm25.466,39.987h-6.082V313.621H370.2v16.665h-6.078V292.577q0-7.788,7.281-7.791h4.562q7.3,0,7.287,7.791Zm23,0H391.808v-45.5h6.085v39.976h8.357Zm35.108-32.639h-6.084v-4.06c0-2.2-.866-3.288-2.592-3.288h-1.526c-1.776,0-2.655,1.09-2.655,3.288v27.881c0,2.2.879,3.294,2.655,3.294h4.118V313.621h-3.167V308.1h9.251v22.185H429.452q-7.033,0-7.04-7.676V292.578q0-7.788,7.04-7.792h4.175q7.735,0,7.731,7.921Zm14.194,32.639h-6.086v-45.5h6.086Zm27.693,0h-6.086V313.621h-6.977v16.665h-6.075V292.577q0-7.788,7.28-7.791h4.569q7.281,0,7.289,7.791Zm27.24,0H504.4v-9.073L497.873,300.5v29.79h-6.08v-45.5h6.08l6.528,21.983V284.786h6.084Zm24.4-39.988h-5.826v39.988h-6.086V290.3h-5.829v-5.513H534.88Z",
    fill: "#818386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.99f1a1ace1ea2718932794c9d23ff492.svg";
export { ForwardRef as ReactComponent };